import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { SessionStateService } from '@abp/ng.core';
import { Observable } from 'rxjs';

/**
 * Asks the API to issue the culture cookie instead of writing it from script.
 *
 * The API localizes its responses from the `.AspNetCore.Culture` cookie. That cookie used to be
 * written by script (ABP core and the language menus), which leaves it without the HttpOnly and
 * Secure attributes (security scan findings QID 150123 / 150122). ABP's request localization
 * middleware writes the same cookie itself, with the server's cookie policy applied, whenever a
 * request carries `culture` and `uiCulture` query parameters. This interceptor adds them to the
 * application configuration request, which ABP sends on every start, so the cookie follows the
 * language stored in the session state without any script side cookie access.
 */
@Injectable()
export class CultureQueryInterceptor implements HttpInterceptor {
  private static readonly applicationConfigurationPath = '/api/abp/application-configuration';

  constructor(private sessionState: SessionStateService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const language = this.sessionState.getLanguage();
    if (!language || !this.isApplicationConfigurationRequest(req.url)) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        setParams: { culture: language, uiCulture: language },
      })
    );
  }

  private isApplicationConfigurationRequest(url: string): boolean {
    const path = url.split('?')[0];
    return path.endsWith(CultureQueryInterceptor.applicationConfigurationPath);
  }
}
